import React, {Component} from 'react';
import { Row, Container } from 'react-bootstrap';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import './App.css';
import './resources/styles/ScbTheme.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import Login from './containers/login/Login';
import Announce from './containers/announce/Announce';
import Contact from './containers/contact/Contact';
import User from './containers/user/User';
import ChangePassword from './containers/changePassword/ChangePassword';
import UserDetail from './containers/userDetail/UserDetail';
import { NotFound, Unauthorized} from './containers/error/Error';
import {authenticate, logout, updateLastLogin} from './resources/API';
import LoadingModal from './components/modal/LoadingModal';
import SimpleModal from './components/modal/SimpleModal';
import jwtDecode from 'jwt-decode';
import moment from 'moment';
import IdleTimer from 'react-idle-timer';
import { MerchantProfileDetail } from './containers/merchantProfileDetail';
import CustomerProfile from './containers/customer/CustomerProfile';
import CustomerDetail from './containers/customerDetail/CustomerDetail';
import Transactions from './containers/transactions/Transactions';
import TransactionDetail from './containers/transactionDetail/TransactionDetail';
import RegistrationReport from './containers/registrationReport/RegistrationReport';
import OnlineRegistrationReport from './containers/onlineregistrationreport/OnlineRegistrationReport';
import Manual from './containers/manual/Manual';
import Sso250Report from './containers/sso250Report/Sso250Report';
class App extends Component {

  constructor(props) {
    super();
    const user = sessionStorage.getItem('lego_user');
    const role = sessionStorage.getItem('lego_user_role');
    this.state = {
      user : JSON.parse(user),
      role : JSON.parse(role),
      merchantProfile : null,
      authResponse : "",
      loadingShow : false,
      modal :{
        header : null,
        body : null,
        footer : null,
        show : false,
        variant : 'scb'
      },
      userReset : '',
      isReset : false,
      downloading : {
        value : false,
        set : (b) => {
          this.setState({
            downloading : {
              ...this.state.downloading,
              value : b
            }
          })
        }
      }
    };
    this.idleTimer = null
  }

  _onIdle = async (e) => {
    this.setState({
      modal: {
              header : "Notification",
              body : "Your session has been expired. Please login again",
              footer : null,
              show : true,
              variant : 'scb'
              }
    });
    await logout(this.state.user.userName);
    sessionStorage.clear();
  }

  handleModalClose = async () => {    
    let modal = this.state.modal;
    modal.show = false;
    this.setState({
      user : null,
      role : null,
      authResponse : "",
      modal: modal,
    });
  }

  handleResetModalClose = async () => { 
    let modal = this.state.modal;
    modal.show = false;
    this.setState({      
      authResponse : "",
      modal: modal,
    });
  }

  handleResetPassword = (isReset) => {
    this.setState({isReset : isReset});
  }

  handleForcePassword = (isForce) => {
    this.setState({isForce : isForce});
  }

  handleRedirectOverview (user, roleList) { 
    let modal = this.state.modal;
    modal.show = false;
    this.setState({      
      authResponse : "",
      modal: modal,
      user : user,
      role : roleList,
      isReset : false
    });
  }

  handleAuthentication = async (userLogin, isReset) => {
    this.setState({
      authResponse : "",
    });

    this.setState({loadingShow : true});
    const response = await authenticate(userLogin.username, userLogin.password, userLogin.newPassword);

    if (response.status === 200){
      const idPayload = jwtDecode(response.body.idToken);
      const roleList = idPayload["custom:auth"] ? idPayload["custom:auth"].split(",") : [];
      sessionStorage.setItem('lego_token',JSON.stringify({
        idToken : response.body.idToken,
        refreshToken : response.body.refreshToken,
        accessToken : response.body.accessToken
      }));

          await updateLastLogin(userLogin.username);
          const merchantProfile = response.body.merchantProfileResponse;
          const userHandler = response.body.userHandlerResponse;
          const user = {
            userName : idPayload["cognito:username"],
            name : idPayload["name"],
            lastLogin : userHandler.lastLogin ?
                    moment(userHandler.lastLogin, "YYYY-MM-DD HH:mm:ss").format("DD MMM YYYY HH:mm:ss") : "N/A",
            merchantProfile : merchantProfile,
            idToken : response.body.idToken,
            refreshToken : response.body.refreshToken,
            accessToken : response.body.accessToken
          }

          if(merchantProfile.specialMerchantCode) {
            roleList.push(merchantProfile.specialMerchantCode);
          }

          sessionStorage.setItem('lego_user',JSON.stringify(user));
          sessionStorage.setItem('lego_user_role',JSON.stringify(roleList));

          if (isReset) {
            const footer = <Button onClick={() => this.handleRedirectOverview(user, roleList)} variant="outline-secondary">Close</Button>                  
            this.setState({
              modal: {
                      header : "Notification",
                      body : "Your password has been changed successfully. You will be redirected to home screen.",
                      footer : footer,
                      show : true,
                      variant : 'scb',
                      backdrop : 'static'
                  }
            });
          } else {
            this.setState({
              user : user,
              role : roleList,
              authResponse : ""
            });
          }
      // }
    } else if (response.status === 202) {
      this.setState({
        userReset : userLogin.username,
        isReset : true
      });
      
    } else {
      if (!isReset) {
        this.setState({
          user : null,
          role : null,
          authResponse : response.body.validationMessages[0].message
        });
      } else {
        if(userLogin.password === userLogin.newPassword){ 
          this.setState({
            modal: {
                    header : "Error",
                    body : "New password cannot be the same as your current password.",
                    footer : null,
                    show : true,
                    variant : 'danger'
                },
            loadingShow:false
          });
          return;
        }
        if (response.body.validationMessages[0].message === "The username or password is incorrect") {
          this.setState({
            modal: {
                    header : "Error",
                    body : "Current password is invalid.",
                    footer : null,
                    show : true,
                    variant : 'danger'
                }
          });            
        } else {            
          this.setState({
            modal: {
                    header : "Error",
                    body : response.body.validationMessages[0].message,
                    footer : null,
                    show : true,
                    variant : 'danger'
                }
          });
        }
      }
    }
    this.setState({loadingShow : false});
  }

  handleLogOut = async () => {
    await logout(this.state.user.userName);

    sessionStorage.clear();
    this.setState({
      user : null,
      role : null,
      authResponse : "",
    });
  }

  isAuthenticated(){
    return this.state.user;
  }

  render() {
    const {role, user, loadingShow, authResponse, modal, userReset, isReset, downloading} = this.state;

    return (
      <React.Fragment>
        <Row className="m-0">
          <Container fluid={true}>
            {this.isAuthenticated()
              ?
              <React.Fragment>
                <IdleTimer
                  ref={ref => { this.idleTimer = ref }}
                  element={document}
                  onIdle={this._onIdle}
                  timeout={1000 * 60 * 15}
                />
                <BrowserRouter>
                  <Header user={user} onLogOut={this.handleLogOut}/>
                  <Switch>
                    <Route exact path="/" render={(props) => <Announce {...props} merchantId={user.merchantProfile.merchantId} username={user.userName} role={role} accessToken={user.idToken}/>} />
                    <Route exact path="/merchant/:action" render={(props) => <MerchantProfileDetail {...props} merchantId={user.merchantProfile.merchantId} username={user.userName} role={role} downloading={downloading} accessToken={user.idToken}/>} />
                    <Route exact path="/user" render={(props) => <User {...props} merchantId={user.merchantProfile.merchantId} username={user.userName} role={role} accessToken={user.idToken}/>} />
                    <Route exact path="/user/:action" render={(props) => <UserDetail {...props} merchantProfile={user.merchantProfile} username={user.userName} role={role} accessToken={user.idToken}/>} />
                    <Route exact path="/user/:action/:merchantId/:userId" render={(props) => <UserDetail {...props} merchantProfile={user.merchantProfile} role={role} accessToken={user.idToken}/>} />
                    <Route exact path="/customer" render={(props) => <CustomerProfile {...props} merchantProfile={user.merchantProfile} username={user.userName} role={role} accessToken={user.idToken}/>} />
                    <Route exact path="/customer/:action/:custProfileId" render={(props) => <CustomerDetail {...props} merchantProfile={user.merchantProfile} role={role} accessToken={user.idToken}/>} />
                    <Route exact path="/reports/transactions/:mode" render={(props) => <Transactions {...props} merchantProfile={user.merchantProfile} username={user.userName} role={role} downloading={downloading} accessToken={user.idToken}/>} />
                    <Route exact path="/reports/transactions/view/:txnNumber" render={(props) => <TransactionDetail {...props} merchantProfile={user.merchantProfile}  username={user.userName} role={role} accessToken={user.idToken}/>} />
                    <Route exact path="/reports/registration" render={(props) => <RegistrationReport {...props} username={user.userName} merchantProfile={user.merchantProfile} role={role} downloading={downloading} accessToken={user.idToken}/>} />
                    <Route exact path="/reports/online-registration-monitoring" render={(props) => <OnlineRegistrationReport {...props} merchantProfile={user.merchantProfile} username={user.userName} role={role} downloading={downloading} accessToken={user.idToken}/>} />
                    <Route exact path="/reports/sso-250-bytes" render={(props) => <Sso250Report {...props} merchantProfile={user.merchantProfile} username={user.userName} role={role} downloading={downloading} accessToken={user.idToken}/>} />
                    <Route exact path="/change-password" render={(props) => <ChangePassword {...props} username={user.userName} role={role} token={user.accessToken} accessToken={user.idToken}/>} />
                    <Route exact path="/manual" render={(props) => <Manual {...props} role={role} />} />
                    <Route exact path="/contact" render={(props) => <Contact {...props} role={role} />} />
                    <Route exact path="/unauthorized" component={Unauthorized} />
                    <Route component={NotFound} />
                  </Switch>
                </BrowserRouter>
              </React.Fragment>
              :
              <React.Fragment>
                <BrowserRouter>
                  <Header user={user} onLogOut={this.handleLogOut}/>
                  {!isReset 
                  ? <Login onAuthen={this.handleAuthentication} authResponse={authResponse} />
                  : <ChangePassword  role={[]} username={userReset} isReset={isReset} authResponse={authResponse} onAuthen={this.handleAuthentication} onCancel={this.handleResetPassword}/>
                  }
                </BrowserRouter>
              </React.Fragment>
              
            }
            <Footer isDownloading={downloading.value}/>
          </Container>
        </Row>
        <LoadingModal show={loadingShow} />
        {isReset ? 
          <SimpleModal        
          modal={modal}
          onClose={this.handleResetModalClose}
          />
        : <SimpleModal
          modal={modal}
          onClose={this.handleModalClose}
          />
        }      
      </React.Fragment>
    );
  }
}

export default App;
